export type AmenitiesType =
  | 'parachute_linens'
  | 'linens'
  | 'espresso_machine'
  | 'hair_dryer'
  | 'lorem_cookware'
  | 'cookware'
  | 'malin+goetz_soap'
  | 'heating'
  | 'air_conditioning'
  | 'tableware'
  | 'laundry'
  | 'professional_cleaning'
  | 'smart_tv'
  | 'tv'
  | 'cable'
  | 'iron'
  | 'grill'
  | 'standing_desk'
  | 'whiteboard'
  | 'hot_tub'
  | 'keyboard'
  | 'peloton'
  | 'pool'
  | 'monitor'
  | 'patio'
  | 'height_chair'
  | 'mouse'
  | 'sonos_speakers'
  | 'wifi'
  | 'group_space';

export enum Amenities {
  parachute_linens = 'Parachute Linens',
  linens = 'Linens',
  espresso_machine = 'Espresso Machine',
  hair_dryer = 'Hair Dryer',
  lorem_cookware = 'Lorem Cookware',
  cookware = 'Cookware',
  'malin+goetz_soap' = 'Malin + Goetz',
  heating = 'Heating',
  air_conditioning = 'Air Conditioning',
  tableware = 'Tableware',
  laundry = 'Laundry',
  professional_cleaning = 'Professional Cleaning',
  smart_tv = 'Smart TV',
  tv = 'TV',
  cable = 'Cable',
  iron = 'Iron',
  grill = 'Grill',
  standing_desk = 'Standing Desk',
  whiteboard = 'Whiteboard',
  hot_tub = 'Hot Tub',
  keyboard = 'Keyboard',
  peloton = 'Peloton',
  pool = 'Pool',
  monitor = 'Monitor',
  patio = 'Patio',
  height_chair = 'Height Chair',
  mouse = 'Mouse',
  sonos_speakers = 'Sonos Speakers',
  wifi = 'Wifi',
  group_space = 'Group Space',
}

export enum AmenitiesTooltip {
  wifi = 'Fast wifi with Eero routers',
  'malin+goetz_soap' = 'Equipped with Malin + Goetz soaps',
  espresso_machine = 'Nespresso machine with pods provided',
  laundry = 'Equipped with private washer and dryer',
  linens = 'High thread count linens and high quality towels',
  standing_desk = 'Equipped for entertaining.',
  monitor = 'Workstation with external monitor.',
}
